module.exports = __webpack_public_path__ + "7ee4edb86e4cc150150b6432f26cb23f.png";